import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d9dd3ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar d-none d-sm-flex w-100 justify-space-between mt-2" }
const _hoisted_2 = { class: "app-logo d-flex align-center gap-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-black mr-2 d-none d-md-block" }, "LoftForParty", -1))
const _hoisted_4 = { class: "app-menu d-flex align-center justify-center" }
const _hoisted_5 = ["to"]
const _hoisted_6 = {
  key: 0,
  class: "mx-2"
}
const _hoisted_7 = ["onClick"]

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import OnlineStatus from '@/components/OnlineStatus.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'AppNavbar',
  setup(__props) {

const store = useStore();
const router = useRouter();
const mainMenu = [{
  id: 1,
  icon: "mdi mdi-format-list-checkbox",
  title: "Заказы",
  path: { path: '/', permission: null },
  badge: 0
},
{ id: 2, icon: "mdi mdi-calendar", title: "Календарь", path: { path: "/calendar" }, permission: null },
{ id: 3, icon: "mdi mdi-calendar-clock", title: "Цены", path: { path: '/prices' }, permission: null },
{ id: 4, icon: "mdi mdi-calendar-clock", title: "Смены", path: { path: '/shifts' }, permission: null },
{ id: 5, icon: "mdi mdi-bell", title: "Уведомления", badge: 0, path: { path: '/notifications' }, permission: null },
{ id: 6, icon: "mdi mdi-account-multiple-outline", title: "Клиенты", path: { path: "/clients" }, permission: "create_clients" },
{ id: 7, icon: "mdi mdi-sofa", title: "Лофты", path: { path: "/lofts" }, permission: "create_lofts" },
{ id: 8, icon: "mdi mdi-account-multiple", title: "Сотрудники", path: { path: "/users" }, permission: "create_user" },
{
  id: 9,
  icon: "mdi mdi-cog",
  title: "Настройки",
  permission: null,
  childs: [
    { id: 903, icon: "mdi mdi-home-city", title: "Заведения", path: { path: "/offices" }, permission: "create_offices" },
    { id: 904, icon: "mdi mdi-shopping", title: "Товары", path: { path: "/services" }, permission: "create_services" },
  ],
}]
const shiftInfoLoading = computed(() => store.getters["shiftService/selectShiftInfoLoading"]);
const userPermissions = computed(() => store.getters["auth/selectUserPermissions"]);
const generatedUserMenu = computed(() => {
  if (!userPermissions.value) return [];
  return mainMenu.map((menuItem) => {
    if (menuItem.childs) {
      menuItem.childs = menuItem.childs.filter((child: any) => {
        if (!child.permission) return true;
        if (!userPermissions.value) return false;
        return userPermissions.value.includes(child.permission || "");
      });
    }
    return menuItem
  }).filter((menuItem) => {
    if (!menuItem.permission) return true;
    if (!userPermissions.value) return false;
    return userPermissions.value.includes(menuItem.permission || "");
  });
});

const handleLogout = async () => {
  const response = await Promise.resolve(store.dispatch('auth/logout'));
  if (response) {
    store.dispatch('snackbarService/showSnackbar', {
      message: 'Вы вышли из системы',
      color: 'success'
    });

    router.push({ path: 'login' });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_img, {
        src: require('@/assets/logo.png'),
        width: "40",
        height: "40",
        class: "mr-2 d-none d-lg-block"
      }, null, 8, ["src"]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(generatedUserMenu.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "d-flex"
        }, [
          (!item.childs)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                style: {"text-decoration":"none","color":"green"},
                class: "mx-2 text-black bold app-menu__item",
                to: item.path
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createBlock(_component_v_menu, { key: 1 }, {
                activator: _withCtx(({ props }) => [
                  _createElementVNode("div", _mergeProps(props, { class: "pointer text-black bold app-menu__item" }), _toDisplayString(item.title), 17)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childs, (i) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: i.id,
                          value: i.title,
                          onClick: _withModifiers(($event: any) => (_ctx.$router.push(i.path)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              style: {"text-decoration":"none","color":"green"},
                              class: "mx-2 text-black bold app-menu__item",
                              to: i.path
                            }, _toDisplayString(i.title), 9, _hoisted_5)
                          ]),
                          _: 2
                        }, 1032, ["value", "onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
        ]))
      }), 128)),
      (!shiftInfoLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(OnlineStatus)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "mx-2 d-flex nowrap app-menu__item",
        onClick: _withModifiers(handleLogout, ["stop"])
      }, [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [
            _createTextVNode("mdi-logout")
          ]),
          _: 1
        })
      ], 8, _hoisted_7)
    ])
  ]))
}
}

})